import { render, staticRenderFns } from "./canadian_certificate_qualification.vue?vue&type=template&id=71b6a0b3&"
import script from "./canadian_certificate_qualification.vue?vue&type=script&lang=js&"
export * from "./canadian_certificate_qualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports